const Constants = Object.freeze({
	EnvironmentTypes: {
		GCP_TEST: 'GCP_TEST',
		GCP_PRE: 'GCP_PRE',
		GCP_PROD: 'GCP_PROD',
	},
	EventTypes: {
		application: 'Application',
		page: 'Page',
		controls: 'UIControl',
		swipe: 'UISwipe',
		exceptions: 'Exception',
		crash: 'Crash',
		network: 'Network',
		custom: 'UICustom',
		UIChange: 'UIChange',
	},
	NavigationTypes: {
		NAVIGATE: 'NAVIGATE',
		COMPLETE_TRANSITION: 'COMPLETE_TRANSITION',
		BACK: 'BACK',
		JUMP_TO: 'JUMP_TO',
		RESET: 'RESET',
		POP: 'POP',
		PUSH: 'PUSH',
		POP_TO_TOP: 'POP_TO_TOP',
		REPLACE: 'REPLACE',
	},
	UIElements: {
		Button: ['onPress'],
		Switch: ['onValueChange'],
		Picker: ['onValueChange'],
		Touchable: ['onPress', 'onPressIn', 'onPressOut', 'onLongPress', 'onFocus', 'onBlurLongPress'],
		Slider: ['onSlidingComplete'],
		TextInput: ['onFocus', 'onBlur'],
		Text: ['onPress', 'onLongPress'],
		RefreshControl: ['onRefresh'],
		TabView: ['onViewChange'],
	},
	HTTPMethod: {
		get: 'GET',
		post: 'POST',
		put: 'PUT',
		patch: 'PATCH',
		delete: 'DELETE',
	},
	ShakingSensitivity: {
		LIGHT: 'LIGHT',
		MEDIUM: 'MEDIUM',
		HARD: 'HARD',
	},
	InvocationEvents: {
		shake: 'shake',
		twoFingersSwipeLeft: 'twoFingersSwipeLeft',
		none: 'none',
	},
	CustomerChannelStringKeys: {
		attachments: 'customer_channel_attachments',
		add_image: 'customer_channel_add_image',
		submit: 'customer_channel_submit',
		privacy_statement: 'customer_channel_privacy_statement',
		description_placeholder: 'customer_channel_description_placeholder',
		privacy_policy: 'customer_channel_privacy_policy',
		title: 'customer_channel_title',
		Send_Button_Title: 'customer_channel_Send_Button_Title',
		data_use_policy: 'customer_channel_data_use_policy',
		edit_image_attach_image: 'customer_channel_edit_image_attach_image',
		required: 'customer_channel_required',
		description_title: 'customer_channel_description_title',
		attachment_sub_title: 'customer_channel_attachment_sub_title',
		max_attachment_size_reached: 'customer_channel_max_attachment_size_reached', //ios only
		quick_action_title: 'customer_channel_quick_action_title',
		quick_action_sub_title: 'customer_channel_quick_action_sub_title',
		quick_action_close_button: 'customer_channel_quick_action_close_button',
		edit_image_undo: 'customer_channel_edit_image_undo',
		edit_image_title: 'customer_channel_edit_image_title',
		edit_image_nav_bar_title: 'customer_channel_edit_image_nav_bar_title',
		web_view_title: 'customer_channel_web_view_title',
		description_characters: 'customer_channel_description_characters',
		// welcome message
		welcome_title: 'welcome_title',
		welcome_button: 'welcome_button',
		welcome_message_none_invocation_event: 'welcome_message_none_invocation_event',
		welcome_message_shake_invocation_event: 'welcome_message_shake_invocation_event',
		welcome_message_swipe_invocation_event: 'welcome_message_swipe_invocation_event',
		//AppRating
		app_rate_title: 'app_rate_title',
		app_rate_description: 'app_rate_description',
		app_rate_submit: 'app_rate_submit',
		app_rate_close: 'app_rate_close',
		app_rate_success_title: 'app_rate_success_title',
		app_rate_success_description: 'app_rate_success_description',
	},
});

export default Constants;
